interface Props {
    text: string
    limit?: number
}

export const Trim = ({text, limit = 150}: Props) => {
    return text.length > limit ?
        text.substring(0, limit - 3) + "..." :
        text;
}